<template lang="pug">
    .guest-footer-control__item.guest-footer-control__item--clickable
        span(@click="showModal = true") GDPR Info Request
        .modal-container.gdpr-request-link-modal(v-if="showModal")
            gdpr-request-modal(@close="showModal = false")
</template>

<script>
import GdprRequestModal from '../modals/gdpr-request-modal'
import TitleModalLayout from '../../layouts/title-modal-layout'

export default {
    name: 'gdpr-request-link',

    components: {
        GdprRequestModal,
        TitleModalLayout,
    },

    data() {
        return {
            showModal: false,
        }
    },
}
</script>

<style lang="scss">
.modal-container.gdpr-request-link-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
}
</style>
